<template lang="pug">
div(:key='this.sectionHandle')
  div(v-if='isSmall').container.mx-auto.max-w-sm
    .flex.flex-wrap.items-center
      div(v-for='item of selection' class='w-1/2').px-6.my-8
        router-link( :to="{name:'item', params:{ sectionHandle, slug:item.slug}}")
          img( :src='item.url').max
          p(v-dompurify-html="item.explanation").text-sm.font-light.text-center

  div(v-else :style="{'height': `${computedWidth + 250}px`}").relative.overflow-hidden.flex.w-full.items-center.justify-center
    div.absolute.inset-0
      div.flex.justify-center.items-center.w-full.h-full
        div(v-in-viewport v-dompurify-html="globals['statement'+upperSectionHandle]" ).leading-none.text-1xl.sm_text-2xl.md_text-3xl.font-light.max-w-sm.sm_max-w-lg.px-32.text-center
    div
      staggered-transition
        rotator-angle(
          v-for="(item,index) of selection"
          :key='item.id' 
          :r="computedR" 
          :index='index' 
          :data-index="index"
          :reverse='false' 
          :duration='"45s"'
          :count='itemsAmount' )
          router-link(:to="{name:'item', params:{ sectionHandle, slug:item.slug}}").pointer-events-auto
            div.w-40
              img( :src='item.url').transform.hover_scale-105.duration-500
              p(v-dompurify-html="item.explanation").text-sm.font-light.text-center
  div(v-in-viewport v-if='chunks.length > 1 && !isSmall').container.mx-auto.w-full.text-center.my-8.font-black.underline.hover_text-acn-green
    p
      a(@click='more') Meer tips
  div(v-in-viewport).container.mx-auto.text-acn-green.max-w-md.text-center.px-4
    p(v-dompurify-html="globals['explanation'+upperSectionHandle]")
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { chunk, upperFirst } from 'lodash'

export default {
  name: 'Section',
  props: {
    sectionHandle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      wantedItemsAmount: 8,
      chunks: [],
      currentChunk: 0,
    }
  },
  computed: {
    ...mapGetters(['isSmall']),
    ...mapState({
      globals: 'globals',
      width: (state) => state.visual.window.width,
      items(state) {
        return state[this.sectionHandle].reduce((items, item) => {
          if (item.image && item.image.length) {
            items.push({
              id: item.id,
              url: item.image[0].url,
              title: item.title,
              slug: item.slug,
              explanation: item.explanation,
            })
          }
          return items
        }, [])
      },
    }),
    upperSectionHandle() {
      return upperFirst(this.sectionHandle)
    },
    selection() {
      return this.chunks[this.currentChunk]
    },
    itemsAmount() {
      return this.selection.length
    },
    computedWidth() {
      return Math.min(600, this.width)
    },
    computedHeight() {
      return this.computedWidth + this.width < 640 ? 100 : 250
    },
    computedR() {
      return this.computedWidth / 2 - 45
    },
    currentSectionName() {
      return this.$store.getters.sections.find(
        (section) => section.handle === this.sectionHandle
      ).title
    },
  },
  watch: {
    sectionHandle() {
      this.resetChunks()
    },
  },
  created() {
    this.resetChunks()
  },
  methods: {
    resetChunks() {
      this.chunks = chunk(this.items, this.wantedItemsAmount)
      this.currentChunk = 0
    },
    more() {
      if (this.currentChunk === this.chunks.length - 1) this.currentChunk = 0
      else this.currentChunk++
    },
  },
  metaInfo() {
    const title = this.currentSectionName
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title,
      meta: [
        {
          vmid: 'og:title',
          content: title,
        },
      ],
    }
  },
}
</script>
